import {
  SetUserPermissionsDto,
  UserPermissionsResponse,
} from '../types/permissions.types';
import { ResponseType } from '../types/shared.types';
import { api } from './api';

/** Permissions of the logged in user. Admin app only. */
export const getMyPermissions = () =>
  api.get<ResponseType<UserPermissionsResponse>>('/v1/users/permissions/me');

export const getUserPermissions = (userId: number | string) =>
  api.get<ResponseType<UserPermissionsResponse>>(
    `/v1/users/${userId}/permissions`
  );

/**
 * Full replace - send the complete list the user should end up with, not a
 * delta. Anything omitted is revoked.
 */
export const setUserPermissions = (
  userId: number | string,
  data: SetUserPermissionsDto
) =>
  api.put<ResponseType<UserPermissionsResponse>>(
    `/v1/users/${userId}/permissions`,
    data
  );
